import { render } from "./developer-profile.vue?vue&type=template&id=9b509892"
import script from "./developer-profile.vue?vue&type=script&lang=js"
export * from "./developer-profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__